import React, { useEffect, useState } from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import InfoCompany from '../../Containers/InfoCompany';
import Feedback from '../../Containers/Feedback';
import IntroductCompany from '../../Containers/IntroductCompany';
import ListPosts from '../../Containers/ListPosts';
import PostMediaList from '../../Containers/PostMediaList';
import ModalLogin from '../../Containers/Modal_Login';
import ModalRegister from '../../Containers/Modal_Register';
import ModalExtraRegister from '../../Containers/ModalExtraRegister';
import ModalExtraRegisterIframe from '../../Containers/ModalExtraRegisterIframe';
import ModalSuccess from '../../Containers/ModalSuccess';
import ModalLike from '../../Containers/ModalLike';
import ModalRegisterPlatform from '../../Containers/ModalRegisterPlatform';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const Profile = () => {
  const [profile, setProfile] = useState();
  const [user, setUser] = useState();
  const [articlesPlatform, setArticlesPlatform] = useState();
  const { name } = useParams();

  useEffect(() => {
    axios.get(`/api/v1/platform/${name}`).then(({ data }) => {
      if (data.success) {
        setProfile(data.payload);
        axios
          .get(`/api/v1/articles/platform/${data.payload.id}`)
          .then(({ data }) => {
            if (data.success) {
              setArticlesPlatform([...data.payload]);
              if (data.payload === null) {
                window.location.href = '/';
              }
            }
          });
        if (data.payload === null) {
          window.location.href = '/';
        }
      }
    });
    axios.get('/api/v1/meta').then(({ data }) => {
      if (data.success) {
        setUser(data.payload.user);
      }
    });
  }, []);

  const getProfile = () => {
    axios.get(`/api/v1/platform/${name}`).then(({ data }) => {
      if (data.success) {
        setProfile(data.payload);
      }
    });
  };

  return (
    <div className='profile-page'>
      <Header />
      <main>
        <div className='profile pr'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-8 col-md-8'>
                <h2 className='title'>Nền tảng đồng hành | {profile?.name}</h2>
                <InfoCompany profile={profile} />
                <IntroductCompany profile={profile} />
              </div>
              <div className='col-lg-4 col-md-4'>
                <PostMediaList articlesPlatform={articlesPlatform} />
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-12 col-md-12'>
                {articlesPlatform && articlesPlatform.length != 0 ? (
                  <ListPosts articlesPlatform={articlesPlatform} />
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-8 col-md-8'>
                <Feedback feedback={profile?.feedback} />
              </div>
            </div>
          </div>
        </div>
        <ModalLogin />
        <ModalRegister />
        <ModalSuccess />
        <ModalLike user={user} capacity={profile?.feedback_can} />
        <ModalRegisterPlatform
          name={profile?.name}
          user={user}
          capacity={profile?.register_can}
          onReload={getProfile}
        />
        <ModalExtraRegister name={profile?.name} />
        <ModalExtraRegisterIframe />
      </main>
      <Footer />
    </div>
  );
};
export default Profile;
